<template>
  <v-dialog
    v-model="myDialog"
    width="100%"
    transition="dialog-bottom-transition"
    content-class="ma-0 align-self-end max-height-100"
  >
    <v-card :style="cardStyle">
      <div style="width: 100%; height: 100%">
        <div
          class="drag-handle d-flex flex-column align-center justify-center"
          @mousedown="startDrag"
          @touchstart="startDrag"
        >
          <div class="handle-bar mb-1"></div>
        </div>
        <div style="width: 100%; height: calc(100% - 24px); overflow-y: auto">
          <v-col cols="12" class="pt-0 pa-4">
            <!-- ========== ========== Main ========== ========== -->
            <v-row v-if="checkMenuMain" no-gutters class="mb-2">
              <span class="text-h6 font-weight-bold">{{ $t("menuMain") }}</span>
            </v-row>
            <v-row
              v-if="checkMenuMain"
              no-gutters
              class="d-flex"
              style="gap: 12px"
            >
              <v-btn
                v-for="(item, index) in menuMain"
                :key="index"
                class="float-panel-btn"
                @click="onClickMain(item)"
              >
                <MenuSymbol
                  position="float_panel"
                  :name="item.name"
                  :type="item.type || 'default'"
                  :symbol="item.symbol || ''"
                  :color="site.color"
                  :is_display="true"
                  :outlined_box="false"
                  :size="36"
                />

                <span
                  class="mt-1 description-label"
                  :style="{
                    width: 'calc(100% + 24px)',
                    color: textColor,
                    fontSize: '12px',
                  }"
                  >{{ mappingTextMenu(item) }}</span
                >
              </v-btn>
            </v-row>

            <v-row
              v-if="checkMenuMain && checkMenuExtend"
              no-gutters
              class="my-6"
            >
              <v-divider></v-divider>
            </v-row>

            <!-- ========== ========== Extend ========== ========== -->
            <v-row v-if="checkMenuExtend" no-gutters class="mb-2">
              <span
                class="text-h6 font-weight-bold grey--text text--darken-1"
                >{{ $t("menuMore") }}</span
              >
            </v-row>
            <v-row
              v-if="checkMenuExtend"
              no-gutters
              class="d-flex"
              style="gap: 12px"
            >
              <v-btn
                v-for="(item, index) in menuExtend"
                :key="index"
                class="float-panel-btn"
                @click="onClickExtend(item)"
              >
                <v-badge
                  overlap
                  color="red"
                  dot
                  :value="item.noti ? true : false"
                >
                  <MenuSymbol
                    position="float_panel"
                    :name="item.name"
                    :type="item.type || 'default'"
                    :symbol="item.symbol || ''"
                    :color="site.color"
                    :is_display="true"
                    :outlined_box="false"
                    :size="36"
                  />
                </v-badge>
                <div
                  class="mt-1 description-label"
                  :style="{ width: 'calc(100% + 24px)', fontSize: '12px' }"
                >
                  {{ mappingTextMenu(item) }}
                </div>
              </v-btn>
            </v-row>
          </v-col>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import MenuSymbol from "./menu/menu-symbol.vue";
import { mapState } from "vuex";

export default {
  inject: ["isAppLoading"],
  emits: ["onClose"],
  props: {
    dialog: {
      default: false,
    },
  },
  components: {
    MenuSymbol,
  },
  data() {
    return {
      myDialog: false,
      height: 50, // ความสูงเริ่มต้น 50vh
      isDragging: false,
      startY: 0,
      startHeight: 50,
    };
  },
  created() {},
  beforeDestroy() {
    // ลบ event listeners เพื่อป้องกัน memory leak
    window.removeEventListener("mousemove", this.onDrag);
    window.removeEventListener("mouseup", this.stopDrag);
    window.removeEventListener("touchmove", this.onDrag);
    window.removeEventListener("touchend", this.stopDrag);
  },
  methods: {
    closeDialog() {
      this.$emit("onClose");
    },
    startDrag(e) {
      this.isDragging = true;
      // รองรับทั้ง Touch และ Mouse
      this.startY = e.type.includes("touch") ? e.touches[0].clientY : e.clientY;
      this.startHeight = this.height;

      // เพิ่ม Event Listener ระดับ window เพื่อให้ลากได้ต่อเนื่องแม้เมาส์จะหลุดจากแถบ handle
      window.addEventListener("mousemove", this.onDrag);
      window.addEventListener("mouseup", this.stopDrag);
      window.addEventListener("touchmove", this.onDrag, { passive: false });
      window.addEventListener("touchend", this.stopDrag);

      // ป้องกันการเลือกข้อความขณะลาก
      document.body.style.userSelect = "none";
    },
    onDrag(e) {
      if (!this.isDragging) return;

      // ป้องกันการ Scroll หน้าพื้นหลังขณะลากบน Mobile
      if (e.type === "touchmove") e.preventDefault();

      const currentY = e.type.includes("touch")
        ? e.touches[0].clientY
        : e.clientY;
      const deltaY = this.startY - currentY;
      const deltaVH = (deltaY / window.innerHeight) * 100;

      let newHeight = this.startHeight + deltaVH;

      // ข้อจำกัดความสูง
      if (newHeight > 100) newHeight = 100;
      if (newHeight < 25) newHeight = 25;

      this.height = newHeight;
    },
    stopDrag() {
      if (!this.isDragging) return;
      this.isDragging = false;
      document.body.style.userSelect = "";

      // Snap Logic (ระบบแม่เหล็ก)
      if (this.height > 80) {
        this.height = 100; // ลากขึ้นสูงเกิน 80% ให้เต็มจอ
      } else if (this.height < 35) {
        this.closeDialog(); // ลากลงต่ำกว่า 35% ให้ปิด
      } else {
        this.height = 50; // กลับมาที่จุดเริ่มต้นครึ่งจอ
      }

      window.removeEventListener("mousemove", this.onDrag);
      window.removeEventListener("mouseup", this.stopDrag);
      window.removeEventListener("touchmove", this.onDrag);
      window.removeEventListener("touchend", this.stopDrag);
    },

    mappingTextMenu(param) {
      let label = param.name;
      const mapping = {
        main: "home",
        mission: "activity",
        reward: "reward",
        transport: "tracking",
        account: "account",
        // Extend
        chat: { name: "menuChatRoom", route: "chat-room" },
        report: { name: "menuInformationCenter", route: "report" },
        campaign: { name: "menuCampaign", route: "campaign" },
        request: { name: "menuRequest", route: "request" },
        warranty: { name: "menuWarranty", route: "warranty" },
        other: { name: "other", route: "other" },
      };
      if (mapping[param.name]) {
        label = this.$t(mapping[param.name]?.name || mapping[param.name]);
      }
      return label;
    },

    onClickMain(param) {
      const mapping = {
        main: "main",
        mission: "mission",
        reward: "reward",
        transport: "transport",
        account: "my-account",
      };
      if (mapping[param?.name]) {
        const curName = this.$router.currentRoute.name;
        const routerName = mapping[param?.name];
        if (curName != routerName) {
          this.isAppLoading(true);
          this.$router
            .push({
              name: routerName,
            })
            .then(() => {
              if (["transport"].includes(routerName)) {
                this.isAppLoading(false);
              }
            });
        }
      }
    },
    onClickExtend(param) {
      const mapping = {
        chat: { name: "menuChatRoom", route_name: "chat-room-list" },
        report: {
          name: "menuInformationCenter",
          route_name: "information-center-list",
        },
        campaign: { name: "menuCampaign", route_name: "campaign-list" },
        request: { name: "menuRequest", route_name: "request-list" },
        warranty: { name: "menuWarranty", route_name: "warranty-list" },
        other: { name: "other", route_name: "other" },
      };
      if (mapping[param?.name]) {
        const curName = this.$router.currentRoute.name;
        const routerName = mapping[param?.name].route_name;
        if (curName != routerName) {
          this.isAppLoading(true);
          this.$router
            .push({
              name: routerName,
            })
            .then(() => {
              if (["transport"].includes(routerName)) {
                this.isAppLoading(false);
              }
            });
        }
      }
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site", "notificationData"]),
    textColor() {
      return this.site.color;
    },
    cardStyle() {
      return {
        height: `${this.height}vh`,
        maxHeight: "100vh",
        // เมื่อกำลังลาก ให้ปิด transition เพื่อให้การลากลื่นไหลตามมือ
        transition: this.isDragging
          ? "none"
          : "height 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)",
        borderTopLeftRadius: this.height == 100 ? "0px" : "28px",
        borderTopRightRadius: this.height == 100 ? "0px" : "28px",
        overflow: "hidden",
      };
    },
    checkMenuMain() {
      let check = false;
      if (
        this.site?.is_use_float_panel_main &&
        this.site?.float_panel_main?.menu?.length > 0
      ) {
        check = true;
      }
      return check;
    },
    checkMenuExtend() {
      let check = false;
      if (
        this.site?.is_use_float_panel_extend &&
        this.site?.float_panel_extend?.menu?.length > 0
      ) {
        check = true;
      }
      return check;
    },
    menuMain() {
      let list = [];
      if (this.site?.float_panel_main?.menu?.length > 0) {
        list = this.site?.float_panel_main?.menu;
      }
      const icon_menu = this.site?.icon_menu?.menu || [];
      for (let item of list) {
        const model = icon_menu.find((x) => x.name == item.name);
        if (model) {
          item.type = model.type;
          item.symbol = model.symbol;
        }
      }
      return list;
    },
    menuExtend() {
      let list = [];
      if (this.site?.float_panel_extend?.menu?.length > 0) {
        list = this.site?.float_panel_extend?.menu;
      }
      const icon_menu = this.site?.icon_menu?.menu || [];
      for (let item of list) {
        if (item.name == "report") {
          item.noti = this.notificationData.report_admin || false;
        } else if (item.name == "request") {
          item.noti = this.notificationData.report_user || false;
        } else if (item.name == "warranty") {
          item.noti = this.notificationData.report_user_warranty || false;
        }
        const model = icon_menu.find((x) => x.name == item.name);
        if (model) {
          item.type = model.type;
          item.symbol = model.symbol;
        }
      }
      return list;
    },
  },
  watch: {
    dialog: {
      handler() {
        this.myDialog = this.dialog;
      },
    },
    myDialog: {
      handler() {
        if (this.myDialog) {
          this.height = 50;
        } else {
          this.$emit("onClose");
        }
      },
    },
  },
};
</script>

<style>
.max-height-100 {
  max-height: 100% !important;
}
</style>

<style scoped>
.drag-handle {
  width: 100%;
  height: 24px;
  cursor: ns-resize; /* Cursor สำหรับลากขึ้นลงบน Desktop */
  user-select: none;
  background-color: #fff;
}
.handle-bar {
  width: 45px;
  height: 5px;
  background-color: #e0e0e0;
  border-radius: 10px;
}

::v-deep .v-btn__content {
  width: 100%;
  flex-direction: column;
}
.float-panel-btn {
  width: 100px;
  height: 80px !important;
  border-radius: 12px;
  background-color: #ffffff !important;
}
.description-label {
  line-height: 1.3;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
